import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useShop } from "@/context/ShopContext";

export default function CheckoutSuccess() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("polling");
  const { clearCart } = useShop();

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("missing"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts++;
      if (attempts > 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); clearCart(); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <section className="py-24 text-center" data-testid="checkout-success">
      {status === "paid" ? (
        <>
          <CheckCircle size={56} weight="thin" className="mx-auto text-[var(--bm-gold)]"/>
          <h1 className="font-serif-bm text-3xl md:text-5xl mt-4">{t("success.title")}</h1>
          <p className="text-sm text-[var(--bm-muted)] mt-3 max-w-md mx-auto">{t("success.sub")}</p>
          <Link to="/shop" className="btn-primary mt-8 inline-flex">{t("success.continue")}</Link>
        </>
      ) : status === "polling" ? (
        <>
          <div className="font-serif-bm text-2xl">Confirming your payment…</div>
          <p className="text-sm text-[var(--bm-muted)] mt-3">This usually takes a few seconds.</p>
        </>
      ) : (
        <>
          <div className="font-serif-bm text-2xl">Payment {status}</div>
          <Link to="/cart" className="btn-secondary mt-6 inline-flex">Back to cart</Link>
        </>
      )}
    </section>
  );
}
